export default __webpack_public_path__ + "static/media/editor-emoji-btn-icon.9b563b7b.svg";